<template>
  <div v-if="api_data.Farmer">
    <table class="table"
           v-if="api_data.Farmer[file_input_name].extra_data.length || api_data.Farmer[file_input_name].question"
    >
      <thead class="thead-light">
      <label-text
          v-bind:text="api_data.Farmer[file_input_name].question || '-'"
          v-bind:label="head_title"
      ></label-text>
      <tr v-if="api_data.Farmer[file_input_name].extra_data.length">
        <th v-for="(form_fields_each,index) in form_fields" scope="col"
            :key="index"
        >
          {{ $t(form_fields_each.label) }}
        </th>
      </tr>
      </thead>
      <tbody v-for="(extra_data_each,index) in api_data.Farmer[file_input_name].extra_data"
             :key="index"
      >
      <tr>
        <td v-for="(form_fields_each,index) in form_fields"
            :key="index"
        >
          {{ extra_data_each[form_fields_each.name] || 'N/A' }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>

export default {
  name: 'show-question-with-note-and-multi-input',
  props: {
    file_input_name: {
      type: String,
      default: function () {
        return ''
      },
    },
    api_data: {
      type: Object,
      default: function () {
        return {}
      },
    },
    head_title: String,
    default_autocomplete_list: {},
    default_question_options: {},
    form_fields: {},
  },
  created() {
    if (this.$props.api_data != undefined
        &&
        this.$props.api_data.Farmer != undefined
    ) {
      this.$props.api_data.Farmer[this.file_input_name] = this.$props.api_data.Farmer[this.$props.file_input_name] || {
        question: 'no',
        extra_data: []
      };
    }
  },
}
</script>
